export class PureOriginalMatchingModel {

  public hitRate: string;
  public pureOriginalMatchingDetailsId: string;
  public versionWinOLSReference: string;
  public tuningName: string;
  public pureOriginalBaseWinOlsRef: string;
  public dateUploaded: string;
  public versionId: string;
  public pureOriginalBaseId: string;
  public dateMatched: string;

  constructor() {
    this.hitRate = "hitRate";
    this.pureOriginalMatchingDetailsId = "pureOriginalMatchingDetailsId";
    this.versionWinOLSReference = "versionWinOLSReference";
    this.pureOriginalBaseWinOlsRef = "pureOriginalBaseWinOlsRef";
    this.dateUploaded = "dateUploaded";
    this.tuningName = "tuningName";
    this.versionId = "versionId"
    this.pureOriginalBaseId = "pureOriginalBaseId"
    this.dateMatched = "dateMatched";
  }

}
